import { Flex, Text } from "@chakra-ui/react";
import { SpotType } from "~/generated/graphql.types";

export const ShowTutorial = ({
  nextSpotType,
  showTutorial,
}: {
  nextSpotType: SpotType;
  showTutorial: boolean;
}) => {
  const tutorialMessage =
    nextSpotType === SpotType.Start
      ? "マップを右クリックしてスタート地点を追加"
      : nextSpotType === SpotType.Destination
      ? "マップを右クリックしてゴール地点を追加"
      : "マップを右クリックして経由地を追加";
  return showTutorial ? (
    <Flex
      h={200}
      justify="center"
      align="center"
      bgColor="#0F2446"
      border="2px dashed white"
    >
      <Text>{tutorialMessage}</Text>
    </Flex>
  ) : (
    <></>
  );
};
